import type { EventName } from "@lit/react";
import { GridSortColumn as GridSortColumnElement, type GridSortColumnEventMap as _GridSortColumnEventMap, } from "@vaadin/grid/vaadin-grid-sort-column.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridSortColumnElement, };
export type GridSortColumnEventMap = Readonly<{
    onDirectionChanged: EventName<_GridSortColumnEventMap["direction-changed"]>;
}>;
const events = { onDirectionChanged: "direction-changed" } as GridSortColumnEventMap;
export type GridSortColumnProps<T1> = WebComponentProps<GridSortColumnElement<T1>, GridSortColumnEventMap>;
export const GridSortColumn = createComponent({
    elementClass: GridSortColumnElement, events, react: React, tagName: "vaadin-grid-sort-column"
}) as <T1>(props: GridSortColumnProps<T1> & React.RefAttributes<GridSortColumnElement<T1>>) => React.ReactElement | null;
